import React from 'react';
import {
    SYNTH,
    MULTI_SYNTH,
    SAMPLED_INSTRUMENT,
    FM_SYNTH,
    METAL_SYNTH} from 'constants/instrument-types.js';
import InstrumentRackComponent from 'components/instruments/InstrumentRackComponent.js';
import RackSynthComponent from 'components/instruments/RackSynthComponent.js';
import ExternalInstrumentComponent from './ExternalInstrumentComponent.js';
import SampledInstrumentComponent from 'components/instruments/sampledInstrument/SampledInstrumentComponent.js';
import FMSynthComponent from 'components/instruments/FMSynthComponent.js';
import MetalSynthComponent from 'components/instruments/MetalSynthComponent.js';
import InstrumentComponent from './InstrumentComponent.js';

export function getInstrumentComponent(track, scrollContainer) {
    if (track === undefined) {
        return undefined;
    }

    if (track.getTrackType() === 'MIDI') {
        return (
            <ExternalInstrumentComponent track={track}/>
        );
    }

    if (track.getTrackType() === 'INSTRUMENT_RACK') {
        return (
            <InstrumentRackComponent
              scrollContainer={scrollContainer}
              track={track}/>
        );
    }

    if (track.getTrackType() !== 'INSTRUMENT') {
        return undefined;
    }

    let {sequencerEngine} = track;
    if (!track.instrument) {
        return [];
    }
    let type  = track.instrument.getInstrumentType();
    if (type === SYNTH) {
        return (
            <InstrumentComponent
              scrollContainer={scrollContainer}
              key={track.trackNumber+'-instrument'}
              track={track}
              instrument={track.getInstrument()}
              />
        );
    } else if (type === MULTI_SYNTH) {
        return (
            <RackSynthComponent
              scrollContainer={scrollContainer}
              key={track.trackNumber+'-instrument'}
              sequencerEngine={sequencerEngine}
              track={track}
              instrument={track.getInstrument()}
              />
        );
    } else if (type === FM_SYNTH) {
        return (
            <FMSynthComponent
              scrollContainer={scrollContainer}
              key={track.trackNumber+'-instrument'}
              sequencerEngine={sequencerEngine}
              track={track}
              instrument={track.getInstrument()}
              />
        );
    } else if (type === METAL_SYNTH) {
        return (
            <MetalSynthComponent
              key={track.trackNumber+'-instrument'}
              scrollContainer={scrollContainer}
              sequencerEngine={sequencerEngine}
              track={track}
              instrument={track.getInstrument()}
              />
        );
    } else if (type === SAMPLED_INSTRUMENT) {
        return (
            <SampledInstrumentComponent
              scrollContainer={scrollContainer}
              key={track.trackNumber+'-instrument'}
              sequencerEngine={sequencerEngine}
              track={track}
              instrument={track.getInstrument()}
              />
        );
    }
}
